export enum Role {
	Administrator = "Administrator",
	User = "User",
	Support = "Support",
	SuperAdministrator = "Super Administrator",
	ViewOnly = "View Only"
}
